import { Node } from "@/@types/ivr";
import { ActionType, BotType, NodeType } from "@/app/ivr/bot/utils/enums";

export const BotTypeText: Record<BotType, string> = {
  [BotType.Automatic]: "operador automático",
  [BotType.Survey]: "encuesta de satisfacción",
};

export const ActionText: Record<ActionType, string | string[]> = {
  [ActionType.NumericDialing]: "Marcación numérica",
  [ActionType.TransferToQueue]: "Transferir a cola",
  [ActionType.EndCall]: "Finalizar llamada",
  [ActionType.BackToNode]: [
    "Volver a un nodo anterior",
    "Repetir nodo inmediato",
    "Volver a reproducir audio",
  ],
  [ActionType.SendWppTemplate]: "Enviar plantilla de WhatsApp",
  [ActionType.VariableCapture]: "Capturar variable",
  [ActionType.SatisfactionRanking]: "Ranking de satisfacción",
  [ActionType.ConnectorApi]: "Consulta API",
};

export function getNodeText(node: Node, parentNodeDetails?: Node): { name: string; identifier: string; complete: string } {
  let name = "";
  let identifier = "";

  if (node.type === NodeType.NumericDialing) {
    name = "Marcación numérica";
    identifier = `MN${node.id}`;
  }

  if (node.type === NodeType.OptionConsultApi) {
    name = node.referencial_name || `Document - Opción ${node.order}`;
  }

  if (node.type === NodeType.Option) {
    name = "Opción";
    identifier = `${node.order}`;
  }

  if (node.type === NodeType.WrongOption) name = "Opción incorrecta";

  if (node.type === NodeType.WrongOptionApi) name = "Opción incorrecta de API";

  if (node.type === NodeType.ExpiredTime) name = "Tiempo expirado";

  if (node.type === NodeType.VariableCapture) {
    name = "Capturar variable";
    identifier = `CV${node.id}`;
  }
  if (node.type === NodeType.SatisfactionRanking) {
    name = "Ranking de satisfacción";
    identifier = `RS${node.id}`;
  }

  return { name, identifier, complete: `${name} ${identifier}` };
}

export const maxAttemptsList: number[] = [3, 2, 1];

export const numericalOptions = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "*", "#", "+"];
